window.LogEngine = {
	
	init: function(relatedType, relatedId){
		MyFacture.customForm();
	},
	
	switchRelatedType: function(me){
		
		var context			= $('#popupWindow:visible').length ? '#popupWindow' : ".tab-v-content";
		var newRelatedType	= me.val();
		
		MyWindow.wait();
//		$('#popupWindow #logsContainer .logs').html('');
		MyFacture.post('logs', {action:'loadTab', relatedtype:newRelatedType, relatedid:0, start : $('input[name="start"]',context).val(), end : $('input[name="end"]', context).val()}, function(data){
			
			$('#popupWindow #logsContainer .logs').html($(".logs",data.logs));
			
			MyWindow.awake();
		}, 'json');
	},
	
	getMoreLogs: function(relatedType, relatedId, type){
		
		var context		= $('#popupWindow:visible').length ? '#popupWindow' : "#content_events";
		var container	= $("#logs"+type+"_"+relatedType+"_"+relatedId);
		var page		= parseInt(container.attr('page'),10)+1;
		var maxPage 	= parseInt(container.attr('page-max'),10);
		var endDate		= $('input[name="end"]', context).val();
		var startDate	= $('input[name="start"]', context).val();
		
		container.attr('page', page);
		
		var options = {
			'type'			: type,
			'relatedtype'	: relatedType,
			'relatedid'		: relatedId,
			'page'			: page,
			'action'		: "getMoreLogs",
			'start'			: startDate,
			'end'			: endDate
		};
		
		MyFacture.post('logs', options, function(data){
			container.find('.logsList').append(data.logsXsl);
			container.animate({ scrollTop: container[0].scrollHeight}, 1000);
			if(data.logRelated.page > 0 && data.logRelated.nbLogs == 0){
				container.find('.logsBtn').hide();
			}
			if (maxPage && page >= maxPage) {
				container.find('.logsBtn').hide();
			}
		}, "json");
		
	},
	
	loadPopup: function(relatedtype, relatedid, title){
		
		var options = {
			title	: title,
			width: 1000,
			buttons	: [{
				text : Loc.g("Fermer"), click : function(){$(this).dialog("close");}
			}],
			callback	: function(){
				LogEngine.init(relatedtype, relatedid);
			}
		};

		MyWindow.load("logs", {action:"loadPopup", relatedtype:relatedtype, relatedid:relatedid}, options);
		
	},
	
	loadTab: function(relatedType, relatedId, target){
		
		var context = $('#popupWindow:visible').length ? '#popupWindow' : ".tab-v-content";
		
		var target = target === undefined ? "#content_events" : target;

		MyFacture.post('logs', {action:'loadTab', relatedtype:relatedType, relatedid:relatedId}, function(data){
			$(target).html(data.logs).show();
			MyFacture.customForm();
		}, 'json');
		
	},
	
	filterByDate : function($date, relatedid, relatedtype) {
		
		var context		= $('#popupWindow:visible').length ? '#popupWindow' : "#content_events";
		var relatedtype = $("#logsSelector",context).val() ? $("#logsSelector",context).val() : relatedtype;
		
		if($date.prop('name') === 'start') {
			
			var startDate	= $date.val();
			var endDate		= $('input[name="end"]',context).val();
			
		} else {
			
			var endDate		= $date.val();
			var startDate	= $('input[name="start"]',context).val();
			
		}
		
		MyFacture.post('logs', {action:'loadTab', relatedid: relatedid, relatedtype : relatedtype ,start : startDate, end : endDate}, function(data){
			$('.logs',context).html($(".logs",data.logs));
			MyWindow.awake();
		}, 'json');
		
	}
	
};
